import PlainInput from 'app/common/ui-next/plain-input'
import PlainLabel from 'app/common/ui-next/plain-label'

import styles from './EditProductionTypeForm.scss'


export enum FormControl {
  Name = 'name'
}

type Props = {
  startValues?: Record<FormControl, string>
  onModify: (modify: boolean) => void
}

export const EditProductionTypeForm = ({ startValues, onModify }: Props) => {
  return (
    <>
      <PlainLabel htmlFor={FormControl.Name} displayAsBlock>
        {'Наименование типа продукции'}
      </PlainLabel>
      <PlainInput
        className={styles.nameInput}
        name={FormControl.Name}
        id={FormControl.Name}
        onValue={v => onModify(!!v)}
        defaultValue={startValues ? startValues[FormControl.Name] : ''}
      />
    </>
  )
}
